import useEmblaCarousel from 'embla-carousel-react'

import Demo from 'src/pages/Demo'
import Advertising from 'src/pages/Demo/Advertising'
import Prices from 'src/pages/Demo/Prices'
import Page from 'src/pages/templates/Page'
import { EmblaProvider } from './EmblaContext'
import { DotButton, useDotButton } from './EmblaCarouselDotButton'
import {
	PrevButton,
	NextButton,
	usePrevNextButtons
} from './EmblaCarouselArrowButtons'
import Toaster from 'src/components/Toaster'

const EmblaCarousel = ({ setShowToastBackdrop }) => {
	const [emblaRef, emblaApi] = useEmblaCarousel()

	const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

	return (
		<EmblaProvider emblaApi={emblaApi}>
			<div className="embla">
				<div className="embla__viewport" ref={emblaRef}>
					<div className="embla__container">
						<div className="embla__slide">
							<Page Component={Demo} title='Intro' setShowToastBackdrop={setShowToastBackdrop}/>
						</div>
						<div className="embla__slide">
							<Page Component={Advertising} title='Advertising' setShowToastBackdrop={setShowToastBackdrop}/>
						</div>
						<div className="embla__slide">
							<Page Component={Prices} title='Prices' setShowToastBackdrop={setShowToastBackdrop}/>
						</div>
					</div>
					<Toaster />
				</div>
				<div className="embla__controls">
					<div className="embla__buttons">
						<PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
						<NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
					</div>
					<div className="embla__dots">
						{scrollSnaps.map((_, index) => (
							<DotButton
								key={index}
								onClick={() => onDotButtonClick(index)}
								className={'embla__dot'.concat(
									index === selectedIndex ? ' embla__dot--selected' : ''
								)}
							/>
						))}
					</div>
				</div>
			</div>
		</EmblaProvider>
	)
}

export default EmblaCarousel
